import React, { useImperativeHandle } from "react";
import    { useState ,useEffect,useRef,forwardRef} from "react";
import qrcode from "../../src/images/qrcode.png";
import { SVGICON } from "../jsx/constant/theme";
import { useLocation,useNavigate } from 'react-router-dom';
import logo from '../jsx/components/Reports/food.jpeg';
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import { Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Invoice = React.forwardRef((props, ref) => {
  const location = useLocation();const componentRef = useRef();
  const componentRef1 = useRef()
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Userdata",
    onAfterPrint: () => setInviteModal(false)
  });
  ;
  const generatePDF1 = useReactToPrint({
    content: () => componentRef1.current,
    documentTitle: "Userdata",
   });
  const searchParams = new URLSearchParams(location.search);

  const receivedDataArray = JSON.parse(searchParams.get('data')) || [];
  const receivedItemId = searchParams.get('id') || '';
  const DiscountAmount = searchParams.get('DiscountAmount') || '';
  const CustomerName = searchParams.get('name') || '';
  const lastdip = searchParams.get('TotalAmount') || '';
  const lastorder = searchParams.get('lastorder') || '';

  const [data3, setData3] = useState({});
  const [toolItems, settoolItems] = useState([]);

  const [orderItems, setOrderItems] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [Discount1, setDiscount1] = useState(0);
  const [report, setreport] = useState({})
  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
    const [order, setOrder] = useState([])
      //  OrderID:'',
      // CustomerID: '',
      // OrderDate: '',
      // TotalAmount: '',
      // DiscountAmount: '',
      // Status: '',
      // UserID: userid,
      // CustomerName: '',
      // DeliveryPersonID: '',
      // DeliveryDate: '',
      // DeliveryTime: '',
      // DelPrice: '',
      // Address: '',
      // GuaranteeTypesID: '',
      // Prepay:'',
   // });
 
   // const intervalId = setInterval(() => {
    //   setOrderDate(new Date());
   //  }, 1000); // Update every 1000 milliseconds (1 second)
 
     // Cleanup function to clear the interval when the component unmounts
   //  return () => clearInterval(intervalId);
  
   
   
  const [inviteModal, setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setOrderItems(props.data);
      //settoolItems(props.data3)
      setOrder(props.data1)
   
    // cal();
     // EditData55(lastorder)
     // const totalAmounts = orderItems.map(item => item.TotalAmount);
      //console.log("totalAmounts", totalAmounts)
    
          
    
      setTotalAmount(order.TotalAmount);
      setInviteModal(true);
    }
    
  }));

  useEffect(() => {
    if (props.data) {
      setOrderItems(props.data);
      //settoolItems(props.data3)
      setOrder(props.data1)
   
    // cal();
     // EditData55(lastorder)
     // const totalAmounts = orderItems.map(item => item.TotalAmount);
      //console.log("totalAmounts", totalAmounts)
    
          
    
      setTotalAmount(order.TotalAmount);    }
}, [props.data]);
  console.log(orderItems)
    const [company, setcompany] = useState([]);
    useEffect(() => {
      const companydata = localStorage.getItem('companies');
      if (companydata) {
        const parsedData = JSON.parse(companydata);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setcompany(singleCompany); // Set state to a single object
      }
    }, []);
  return (
    <Modal className="modal fade" id="exampleModal1" style={{height:'700px'}} size="l" show={inviteModal} onHide={() => setInviteModal(false)} centered>
    <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card mt-3">
             
              <div className="card-body" ref={componentRef}  dir="rtl">
              {/* <div className="row">
                    <div className="col-xl-12 text-center row">
                    <div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      }}>  <div 
    style={{
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
                    <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                   <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter',  marginRight: '-15px'}}>{company.Description}</h2>  </div>
                   <div className="d-flex">                    <i class="fa-solid fa-location-dot pt-1 ps-2" style={{color:'#8e2927'}}></i>
                    <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> {company.Address}</h2> <i class="fa-solid fa-phone-flip p-1 px-2" style={{color:'#8e2927'}}></i><h5 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}>{company.ContactNumber}</h5></div>
</div> 

 <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "150px", width: "150px",  marginTop: '-10px',  marginLeft: '-30px' }} />

                     </div>
                  </div> 
                  </div>  */}
 
                 
                <div className="table-responsive">
                <table className="table table-bordered verticle-middle table-responsive-sm" style={{ marginBottom:'0px',borderCollapse: "unset", borderWidth: '1 px' }}>
                <tbody>
                <tr style={{width:'100%'}}> 
                    <td style={{ boxShadow: '0 1px 1px 0 black' , border: '1px solid #ccc' }}>الزبون  :{order.supplier?.SupplierName || ''}</td>
                    <td style={{ boxShadow: '0 1px 1px 0 black',border: '1px solid #ccc' }}> نوع الفاتورة :نهائية</td>
                  </tr>
                  <tr style={{width:'100%'}}>
                    <td style={{ boxShadow: '0 1px 1px 0 black' , border: '1px solid #ccc' }}>تاريخ الطلبية:{order.OrderDate}</td>
                    <td style={{ boxShadow: '0 1px 1px 0 black',border: '1px solid #ccc' }}>  رقم الفاتورة: {order.InvoiceNumber} </td>
                  </tr></tbody>
                  </table>
                  <div className="table-responsive active-projects dlab-scroll task-table my-2 mx-2" style={{  height: "200px" }}>

                
                  <table className="table table-bordered verticle-middle table-responsive-sm" style={{marginBottom:'0px',marginTop:"1px"}}>
                     <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                    
                      <tr>
                        <th className="center">#</th>
                        <th>الصنف</th>
                         <th className="right">سعر القطعة</th>
                        <th className="center">الكمية</th>
                        <th className="right">المجموع</th>
                      </tr>
                    </thead>
                    <tbody>
                    {orderItems.map((item, ind)=>(
                                                    <tr className="center" key={ind}>
                                                        <td className="center">{ind}
                                                       </td>
                                                        <td className="left strong">{item.parts.PartName}  
                                                       </td>	
                                                        
                                                       <td className="right">{item.UnitPrice}</td>

                                                        <td className="center">{item.Quantity}</td>
                                                        <td lassName="right">{item.Quantity*item.UnitPrice}د</td>
                                                    </tr>  
                                                ))}
                         {orderItems.map((item, ind)=>(
                                                    <tr className="center" key={ind}>
                                                        <td className="center">{ind}
                                                       </td>
                                                        <td className="left strong">{item.parts.PartName}  
                                                       </td>	
                                                        
                                                       <td className="right">{item.UnitPrice}</td>

                                                        <td className="center">{item.Quantity}</td>
                                                        <td lassName="right">{item.Quantity*item.UnitPrice}د</td>
                                                    </tr>  
                                                ))}
                       
                      {orderItems.map((item, ind)=>(
                                                    <tr className="center" key={ind}>
                                                        <td className="center">{ind}
                                                       </td>
                                                        <td className="left strong">{item.parts.PartName}  
                                                       </td>	
                                                        
                                                       <td className="right">{item.UnitPrice}</td>

                                                        <td className="center">{item.Quantity}</td>
                                                        <td lassName="right">{item.Quantity*item.UnitPrice}د</td>
                                                    </tr>  
                                                ))}
                       
                 
                    </tbody>
                    <tbody>
                    
                
                     
               
                  </tbody>
                  </table>
                </div>  </div>
                <div className="row">
                  <div className="col-lg-12 col-sm-5 mt-0 pt-0 "  >
                    <table className="table " style={{borderleft: '#E6E6E6 solid 1px',float:'right',
  marginleft: "0px"}}>
                      <tbody>
                        <tr>
                          <td className="left">
                            <strong>سعر التوصيل</strong>
                          </td>
                          <td className="right">
                            <strong>{order.DelPrice}</strong>
                            <br />
                           
                          </td>
                          </tr>
                        
                         
                        
                        <tr>
                          <td className="left">
                            <strong>الصافي</strong>
                          </td>
                          <td className="right">
                          
                            <strong>
                              {order.TotalAmount}
                            </strong>
                               <br />
                           
                          </td>
                          
                        </tr>
                        
                       
                          <tr>
                          <td className="left">
                            <strong>الباقي</strong>
                          </td>
                          <td className="right">
                            <strong>{order.ReastAmount}</strong>
                            <br />
                           
                          </td>
                          </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
          
         <div className="modal-footer">
            <button  className="btn btn-primary m-2" onClick={generatePDF}>طباعه الفاتورة</button>
 
          </div> </div>  </div>
          
        </div>
      </div>
   
    </Modal>
  );
});

export default Invoice;
